import Alignment from "../SVGComponents/torque-icons/Alignment";
import Battery from "../SVGComponents/torque-icons/Battery";
import Brake from "../SVGComponents/torque-icons/Brake";
import MultiPointInspection from "../SVGComponents/torque-icons/MultiPointInspection";
import OilChange from "../SVGComponents/torque-icons/OilChange";
import CarService from "../SVGComponents/torque-icons/CarService";
import TireRotation from "../SVGComponents/torque-icons/TireRotation";
import Transmission from "../SVGComponents/torque-icons/Transmission";
import WindshieldWipers from "../SVGComponents/torque-icons/WindshieldWipers";
import TorqueDefault from "../SVGComponents/torque-icons/TorqueDefault";
import Star2 from "../SVGComponents/Star2";
import Schedule from "../../assets/SVGComponents/torque-icons/Schedule";
import Repair from "../SVGComponents/torque-icons/Repair";

function fetchDetailIcon(title, color, size) {
    let iconMap = {
        default: (
            <TorqueDefault fill={color ?? null} svgIconSize={`${size}px`} />
        ),
        schedule: <Schedule fill={color ?? null} svgIconSize={`${size}px`} />,
        alignment: <Alignment fill={color ?? null} svgIconSize={`${size}px`} />,
        battery: <Battery fill={color ?? null} svgIconSize={`${size}px`} />,
        brake: <Brake fill={color ?? null} svgIconSize={`${size}px`} />,
        inspection: (
            <MultiPointInspection
                fill={color ?? null}
                svgIconSize={`${size}px`}
            />
        ),
        oil: <OilChange fill={color ?? null} svgIconSize={`${size}px`} />,
        service: <CarService fill={color ?? null} svgIconSize={`${size}px`} />,
        tire: <TireRotation fill={color ?? null} svgIconSize={`${size}px`} />,
        transmission: (
            <Transmission fill={color ?? null} svgIconSize={`${size}px`} />
        ),
        wiper: (
            <WindshieldWipers fill={color ?? null} svgIconSize={`${size}px`} />
        ),
        specials: <Star2 fill={color ?? null} svgIconSize={`${size}px`} />,
        homepage: <Repair fill={color ?? null} svgIconSize={`${size}px`} />,
    };

    iconMap = {
        ...iconMap,
        /* icons that are the same */
        tires: iconMap["tire"],
        "schedule service": iconMap["schedule"],
        parts: iconMap["battery"],
    };

    const matchedKeys = Object.keys(iconMap).filter((key) =>
        title.toLowerCase().includes(key)
    );

    if (matchedKeys.length) return iconMap[matchedKeys[0]];

    return iconMap["default"];
}

export default fetchDetailIcon;
